import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@/lib/auth/session';

// The root path has no content of its own — it's just an entry point that forwards
// to the right place before anything renders. Doing this in `beforeLoad` (rather than
// a component that redirects on mount) means there's no flash of an empty page:
// authenticated users go straight to the dashboard, everyone else to /login.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // session.ts reads synchronously, so the decision happens before render — and
    // it counts a still-valid refresh token as authenticated, matching the client.
    throw redirect({ to: isAuthenticated() ? '/admin/dashboard' : '/login' });
  },
});